/**
 * Meeting card component
 */

import {Link} from 'react-router-dom';
import type {MeetingListItem} from '@voxapilot/shared';
import {ROUTES} from '../../config/constants';
import {cn} from '../../utils/cn';

interface MeetingCardProps {
  meeting: MeetingListItem;
}

export function MeetingCard({meeting}: MeetingCardProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300';
      case 'processing':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300';
      case 'recording':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300';
      case 'draft':
        return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    }
  };

  return (
    <Link
      to={ROUTES.MEETING_DETAIL(meeting.id)}
      className="block bg-white dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition-shadow p-6"
    >
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          {meeting.title}
        </h3>
        <span
          className={cn(
            'px-2 py-1 text-xs font-medium rounded-full',
            getStatusColor(meeting.status)
          )}
        >
          {meeting.status}
        </span>
      </div>

      {meeting.scheduledDate && (
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          {new Date(meeting.scheduledDate).toLocaleDateString()}
        </p>
      )}

      {meeting.transcriptPreview && (
        <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-2 mb-2">
          {meeting.transcriptPreview}
        </p>
      )}

      <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400">
        <span>
          {new Date(meeting.createdAt).toLocaleDateString()}
        </span>
        {meeting.actionItemsCount !== undefined && meeting.actionItemsCount > 0 && (
          <span>{meeting.actionItemsCount} action items</span>
        )}
      </div>
    </Link>
  );
}

